const GITLAB_PIPELINES_PROXY_URL = "/gitlab/api";
const GITLAB_ANNOTATION = "gitlab.com/project-slug";
const GITLAB_JOBS_ANNOTATION = "gitlab.com/jobs";

export { GITLAB_ANNOTATION, GITLAB_JOBS_ANNOTATION, GITLAB_PIPELINES_PROXY_URL };
//# sourceMappingURL=index.esm.js.map
